import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GetGallery, DeleteGallery } from '../../../API/admin'
import Loader from '../Common/Loader';
import Swal from 'sweetalert2'
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'

const Faq = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Gallery', to: '/list-Gallery', active: true },
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const Navigate = useNavigate();
    let [loaderStatus, setloaderStatus] = useState(true)

    const [FaqDetail, setFaqDetail] = useState({
        question: '',
        answer: ""
    });
    const [allGallery, setallGallery] = useState([]);
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        getGalleryAPI()
    }, [])

    let getGalleryAPI = async () => {
        let res = await GetGallery()
        console.log(res.data)
        if (res.status) {
            setallGallery(res.data);
        } else {
            setallGallery([]);
        }
    }

    // const HandelChange = (event) => {
    //     // event.preventDefault;
    //     // console.log(event.target.value);
    //     let search = event.target.value;
    //     // console.log("yes");
    //     // let usersarr = Users;
    //     const subArr = alluser.filter(user => (user.fname.includes(search) || (user.corporate_email!=null && user.corporate_email.includes(search)) || user.email.includes(search)) );
    // //   console.log("sub",subArr);
    //   setUsers(subArr);
    //     // callAPI(search);

    // }

    const HandelDelete = async (urlid) => {
        let res = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure , you want to delete this Gallery record?",
            // icon: "warning"
        });
        if (res.isConfirmed) {
            let callAPI = async () => {
                let GalleryData = {
                    id: urlid
                }

                let res = await DeleteGallery(GalleryData);
                if (res.status) {
                    enqueueSnackbar(" Gallery record Deleted successfully", {
                        variant: 'success', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    getGalleryAPI()
                } else {
                    enqueueSnackbar("Can not delete  Gallery record", {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    Navigate('/gallery')
                }
            }
            callAPI();
        }
    }

    // const detailFaq = async (id) => {
    //     let res = await DetailFaq(id);
    //     setFaqDetail({
    //         question: res.data.question,
    //         answer: res.data.answer
    //     })
    //     setVisible(true)
    //     console.log(res)
    // }

    return (
        <>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h3 className="card-title mb-3">
                                Gallery
                            </h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm={3}>

                        </CCol>
                        {/* Select box */}
                        <CCol sm={3}>

                        </CCol>
                        <CCol sm={6} className="" >
                            <Link to='/gallery/create'>
                                <CButton className='float-end text-white' color="info" >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Add Record</CButton>
                            </Link>
                        </CCol>
                    </CRow><br />
                    {/* <MainChart /> */}
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center custom_scroll_table_scroll"
                    >
                        <CTable striped className=''>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Tournament</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Game</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Team</CTableHeaderCell>
                                    {/* <CTableHeaderCell scope="col">Photos</CTableHeaderCell> */}
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {allGallery.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No data found</td>
                                    </tr>
                                ) : (
                                    allGallery.map((entry, index) => (
                                        <CTableRow>
                                            <CTableHeaderCell key={index}>{index + 1}</CTableHeaderCell>
                                            <CTableDataCell key={index}>{entry.tournament_id.name}</CTableDataCell>
                                            <CTableDataCell key={index}>{entry.game_type == 'table_tenis' ? 'Table Tenis' : entry.game_type == '2k_run' ? '2k Run' : entry.game_type == 'bowling' ? 'bowling' : 'badminton'}</CTableDataCell>

                                            <CTableDataCell key={index}>{entry.team_id.domain} </CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div className='d-flex justify-content-center'>
                                                    <Link to={`/gallery/edit?id=${entry.id}`}>
                                                        <CButton className="bi bi-pencil text-white admin_btn_space" color="warning"></CButton>
                                                    </Link>
                                                    <CButton className='bi bi-trash-fill text-white admin_btn_space' color="danger" onClick={() => HandelDelete(entry.id)}></CButton>
                                                </div>
                                            </CTableDataCell>

                                        </CTableRow>
                                    ))
                                )}
                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>

            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="ScrollingLongContentExampleLabel"
            >
                <CModalHeader>
                    <CModalTitle id="ScrollingLongContentExampleLabel">FAQ</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <h5>Question: </h5>
                    <p className='mb-3'>
                        {FaqDetail.question}
                    </p>
                    <h5> Answer :</h5>
                    <p>
                        {FaqDetail.answer}

                    </p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => setVisible(false)}>
                        Close
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}
export default Faq;